import { GenreIndex, genresSsrLogic } from '@components/pages/genres';
import { GenreDetails, genreDetailsSsrLogic } from '@components/pages/genres/details';
import { Default } from '@components/templates/layouts';
import { prerenderPaths } from '@lib/graphql/helpers/prerenderPaths';
import { decodeOptions } from '@src/utils/urlHelpers';
import type { GetStaticPaths, GetStaticProps } from 'next/types';

function Genres({ data, slug }) {
  if (slug === 'index') {
    return <GenreIndex />;
  }
  return <GenreDetails data={data} />;
}

export const getStaticPaths: GetStaticPaths = async () => {
  return {
    paths: await prerenderPaths(['/genres/index']),
    fallback: 'blocking',
  };
};

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const options = decodeOptions(params?.slug);

  if (options.slug === 'index') {
    const result = await genresSsrLogic();
    return result;
  }

  const result = await genreDetailsSsrLogic({ slug: options.slug });
  return result;
};

Genres.PageLayout = Default;

export default Genres;
